
import { Search } from "lucide-react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useSearchState } from "@/hooks/useSearchState";

export const SearchInput = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { searchQuery, setSearchQuery } = useSearchState();
  const inputRef = useRef<HTMLInputElement>(null);

  // Update searchQuery when URL search param changes or when navigating with state
  useEffect(() => {
    const query = searchParams.get('q');
    const stateQuery = location.state?.searchQuery;
    console.log('URL or state query changed:', { query, stateQuery });
    
    if (query !== null) {
      setSearchQuery(query);
    } else if (stateQuery) {
      setSearchQuery(stateQuery);
    }
  }, [searchParams, location.state, setSearchQuery]);

  // Focus input when navigating to search page
  useEffect(() => {
    if (location.pathname === '/search' && inputRef.current) {
      inputRef.current.focus();
    }
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      console.log('Searching for:', searchQuery);
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleFocus = () => {
    if (location.pathname !== '/search') {
      console.log('Navigating to search with query:', searchQuery);
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`, { 
        state: { previousPath: location.pathname }
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Search input changed:', e.target.value);
    setSearchQuery(e.target.value);
  };

  return (
    <form onSubmit={handleSearch} className="relative max-w-xl mx-auto w-full">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
      <input
        ref={inputRef}
        type="text"
        placeholder="Search collections, translations, training data..."
        value={searchQuery}
        onChange={handleChange}
        onFocus={handleFocus}
        className="w-full h-10 pl-10 pr-4 py-2 bg-card border-none rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors"
      />
    </form>
  );
};
